// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2022":"38616885","3327":"2c88f91d"}[chunkId] + ".chunk.css";
};